import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class MbEventListenerService {

  private event$: BehaviorSubject<ContainerAndEvent> = new BehaviorSubject({} as ContainerAndEvent)

  update (event: Event, containerId?: string): void {
    this.event$.next({ event: event, containerId: containerId })
  }

  retrieve (): Observable<ContainerAndEvent> {
    return this.event$.asObservable()
  }
}

export interface ContainerAndEvent {
  containerId?: string;
  event: Event;
}
